import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private selectedCurrency = new BehaviorSubject<'USD' | 'INR' | 'JPY'>('USD'); // Default: USD
  currency$ = this.selectedCurrency.asObservable();

  setCurrency(currency: 'USD' | 'INR' | 'JPY') {
    this.selectedCurrency.next(currency);
  }

  getCurrency(): 'USD' | 'INR' | 'JPY' {
    return this.selectedCurrency.getValue();
  }

  
}
